/**
 * /app/slabs — list of saved slab designs.
 * Thin wrapper over DesignsList configured for the "losas" module.
 */

import { Layers } from 'lucide-react';
import { DesignsList } from '@/features/designs/DesignsList';

export function LosasIndexPage() {
  return (
    <DesignsList
      module="losas"
      description="Diseño de losas aligeradas y macizas — abre una guardada o crea una nueva."
      icon={<Layers size={24} strokeWidth={1.5} />}
    />
  );
}
